import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'learner-dashboard.about.page-title',
    defaultMessage: 'About',
  },
  contactInformation: {
    id: 'learner-dashboard.about.contact-information',
    defaultMessage: 'Contact information',
  },
  organizationName: {
    id: 'learner-dashboard.about.organization-name',
    defaultMessage: 'Organization',
  },
  contactEmail: {
    id: 'learner-dashboard.about.contact-email',
    defaultMessage: 'Email',
  },
  phoneNumber: {
    id: 'learner-dashboard.about.phone-number',
    defaultMessage: 'Phone',
  },
  country: {
    id: 'learner-dashboard.about.country',
    defaultMessage: 'Country',
  },
  address: {
    id: 'learner-dashboard.about.address',
    defaultMessage: 'Address',
  },
  linksTitle: {
    id: 'learner-dashboard.about.links-title',
    defaultMessage: 'Links & resources',
  },
  linksDescription: {
    id: 'learner-dashboard.about.links-description',
    defaultMessage: 'Helpful links provided by your organization.',
  },
  loadError: {
    id: 'learner-dashboard.about.load-error',
    defaultMessage: 'Couldn\'t load organization details. Refresh to try again.',
  },
});

export default messages;
